export default {"src":"/_next/static/media/plus_24.4d5ea1d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};